"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    disabled: false,
    loading: false,
    onClick: function () {
        // action
    },
    textOverflowHandling: 'none',
    invertColors: false,
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map